var _path, _ellipse, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserLogs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 14.75H18.4336C18.3402 14.75 18.2931 14.75 18.2536 14.764C18.2174 14.7768 18.1865 14.7968 18.1642 14.8217C18.1371 14.851 18.1233 14.89 18.0953 14.9683L17.2878 17.2504C17.1842 17.542 17.1327 17.688 17.0549 17.7257C17.0229 17.7417 16.9854 17.7501 16.947 17.75C16.9086 17.7499 16.8711 17.7412 16.8393 17.725C16.7616 17.6867 16.7113 17.5404 16.6109 17.2484L14.8896 12.2516C14.7887 11.9596 14.7384 11.8133 14.6607 11.775C14.6289 11.7588 14.5914 11.7501 14.553 11.75C14.5146 11.7499 14.4771 11.7583 14.4451 11.7743C14.3673 11.812 14.3158 11.9576 14.2122 12.2496L13.4047 14.5313C13.3767 14.61 13.3629 14.649 13.3362 14.678C13.3138 14.7031 13.2828 14.7231 13.2464 14.736C13.2069 14.75 13.1602 14.75 13.0664 14.75H11.75",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.15952,
    cy: 4.58331,
    rx: 4.71811,
    ry: 3.83331,
    stroke: "#3D3D3D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.372 11.75H4.62175C1.97529 11.75 -0.395218 13.8445 1.34651 15.5523C2.53096 16.7137 4.48969 17.5 7.49685 17.5",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogs);
export default __webpack_public_path__ + "static/media/User Logs.9935313379448bdfbba33544a60c829d.svg";
export { ForwardRef as ReactComponent };